// REACT
import React from "react";

// MATERIAL-UI
import { Grid } from "@mui/material";
interface DepositAddressErrorProps {
  errorMessage: string;
}

const DepositAddressError = (props: DepositAddressErrorProps) => {
  return (
    <Grid container justifyContent="center" alignItems="center" style={{ height: "100%" }}>
      <Grid item xs={12} container justifyContent="center">
        <h3>{props.errorMessage}</h3>
      </Grid>
    </Grid>
  );
};

export default DepositAddressError;
